import { useState, useEffect } from "react";

const usePagination = (items = [], itemsPerPage) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Ensure items is always an array
  const itemsArray = Array.isArray(items) ? items : [];

  const totalPages = Math.ceil(itemsArray.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1); // Reset to the first page when items change
  }, [itemsArray]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = itemsArray.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return {
    currentItems,
    currentPage,
    totalPages,
    handlePageChange,
  };
};

export default usePagination;
